import * as S from './slide-indicators.styled';

interface SlideIndicatorsProps {
  currentSlide: number;
  totalSlides: number;
}

export const SlideIndicators = ({ currentSlide, totalSlides }: SlideIndicatorsProps) => {
  if (totalSlides <= 1) {
    return null;
  }

  return (
    <S.Wrapper>
      {Array.from({ length: totalSlides }).map((_, index) => (
        <S.Indicator key={index} isActive={index === currentSlide} />
      ))}
    </S.Wrapper>
  );
};
